import { useEffect, useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useRatings(figurineId: string) {
  const { user } = useAuth();
  const [userRating, setUserRating] = useState<number | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!user || !figurineId) return;
    supabase
      .from('ratings')
      .select('stars')
      .eq('figurine_id', figurineId)
      .eq('user_id', user.id)
      .maybeSingle()
      .then(({ data }) => setUserRating(data ? data.stars : null));
  }, [user, figurineId]);

  const rate = useCallback(async (stars: number) => {
    if (!user) return { error: 'Musisz być zalogowany, aby oceniać.' };
    setSubmitting(true);
    const { error } = await supabase.from('ratings').upsert(
      { figurine_id: figurineId, user_id: user.id, stars, updated_at: new Date().toISOString() },
      { onConflict: 'figurine_id,user_id' }
    );
    if (!error) setUserRating(stars);
    setSubmitting(false);
    return { error: error?.message ?? null };
  }, [user, figurineId]);

  return { userRating, submitting, rate };
}
